// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-3cfX67ZGL5kOx2RPTbMdzI"};